import AutoTimelineSequence from "../../MilestoneSequence/AutoTimelineSequence.jsx";
import StakeholderCardWithData from "../Stakeholders/stakeholderValuesAndInterests/StakeholderCardWithData.jsx";
import MeetingPersonalityCard from "./MeetingPersonalityCard";
// import CurrentStateProfileCard from "../Identity/CurrentYou/CompletionPages/CurrentStateProfileCard.jsx";
import ProfileCard from "../Identity/CurrentYou/ProfileCard.jsx";
import UnmetNeedsCard from "../UnmetNeeds/UnmetNeedsCard.jsx";
import StakeholderListCard from "../Stakeholders/StakeholderListCard.jsx";

export default function MeetingPersonalitySequence({ userId, onNextStep }) {
  const steps = [
    {
      position: "center",
      circles: { left: "", center: "", right: "Future Identity" },
      component: ProfileCard,
      props: {
        mode: "api",
        userId, // <-- now receives correctly
      },
      duration: 5000,
    },
    {
      position: "left",
      circles: { left: "", center: "Value Mapping", right: "Value & Pitch" },
      component: UnmetNeedsCard,
      props: {
        mode: "api",
        userId, // <-- now receives correctly
      },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "1st Meeting with Career Coach",
        center: "",
        right: "Visibility Mapping",
      },
      component: StakeholderListCard,
      props: {
        mode: "api",
        userId, // <-- now receives correctly
      },
      duration: 5000,
    },
    {
      position: "right",
      circles: {
        left: "Visibility Mapping",
        center: "",
        right: "What’s in it for me?",
      },
      component: StakeholderCardWithData,
      props: {
        mode: "api",
        userId, // <-- now receives correctly
      },
      duration: 5000,
    },
    {
      position: "center",
      circles: {
        left: "What’s in it for me?",
        center: "",
        right: "2nd Meeting...",
      },
      component: MeetingPersonalityCard,
      props: {
        mode: "api",
        userId,
        showCTA: true,
      },
      final: true,
    },
  ];

  return <AutoTimelineSequence steps={steps} onComplete={onNextStep} />;
}
